/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { QuestionnaireStrictHttpResponse } from '../../questionnaire-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetQuestionnaireDetailRequestModel } from '../../models/get-questionnaire-detail-request-model';
import { QuestionnaireDetailModel } from '../../models/questionnaire-detail-model';

export interface ApiConsumerQuestionnaireDetailPost$Params {
      body?: GetQuestionnaireDetailRequestModel
}

export function apiConsumerQuestionnaireDetailPost(http: HttpClient, rootUrl: string, params?: ApiConsumerQuestionnaireDetailPost$Params, context?: HttpContext): Observable<QuestionnaireStrictHttpResponse<QuestionnaireDetailModel>> {
  const rb = new RequestBuilder(rootUrl, apiConsumerQuestionnaireDetailPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as QuestionnaireStrictHttpResponse<QuestionnaireDetailModel>;
    })
  );
}

apiConsumerQuestionnaireDetailPost.PATH = '/api/consumer/questionnaire/detail';
